import CreditAccount from 'app/src/data/models/CreditAccount';
import RetailCollection from 'app/src/data/models/RetailCollection';
import URLHelper from 'app/src/data/models/utils/URLHelper';

export default class CreditAccountCollection extends RetailCollection {
  get model() {
    return CreditAccount;
  }

  /**
   * Return the REST url for collection of CreditAccounts
   * @returns {string} the url representing the REST endpoint
   */
  url() {
    return URLHelper.getAccountURL('/CreditAccount.json');
  }

  /**
   * Overridden to parse out superfluous json that the current LSCloud returns us
   * @param response
   * @returns {*}
   */
  parse(response) {
    // response.CreditAccount is an array of the CreditAccount structures we want.
    // Return it directly if an object is found; otherwise return an empty array and let
    // Backbone handle it
    return response.CreditAccount || [];
  }
}
